(ns machtfit.settlement-recipients.rules)

(comment
  ;; a rule is a condition with a result
  {:condition {:some-key "some-value"
               :some-other-key "some-other-value"
               :yet-another-key "another-value"}
   :result "some-result"}

  ;; a rule can match or not match a subject-group, which looks like this:
  {:subject {:some-key "a-value"
             :some-other-key nil}
   ;; special key
   :count 45}

  ;; a rule matches a subject-group if all keys with non-nil values from the rule match the
  ;; corresponding keys in the subject-group

  ;; when a rule matches a subject-group, its count is added to the rule's result
  )

(defn matches? [condition subject]
  (every? #(= true %) (for [[k v] condition
                            :when (not (nil? v))]
                        (= v (k subject)))))

(defn add-counts [rules groups]
  (let [reducer (fn [{:keys [rules-with-count groups]}
                     rule]
                  (let [{matched-groups true
                         unmatched-groups false} (group-by #(matches? (:condition rule) (:subject %)) groups)
                        rule-total-count (apply + (map :count matched-groups))]
                    {:rules-with-count (conj rules-with-count (assoc rule :count rule-total-count))
                     :groups unmatched-groups}))
        result (reduce reducer {:rules-with-count [] :groups groups} rules)]
    (-> result
        (dissoc :groups)
        (assoc :unruled-employees-count (apply + (map :count (:groups result)))))))
